import React, {
  createContext, useContext, useEffect, useMemo, useState,
} from 'react';

const APP_THEME_STORAGE_KEY = 'algodoor-app-theme';

const AppThemeContext = createContext(null);

const readInitialTheme = () => {
  if (typeof window === 'undefined') return 'dark';
  const storedTheme = window.localStorage.getItem(APP_THEME_STORAGE_KEY);
  return storedTheme === 'light' ? 'light' : 'dark';
};

export const AppThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(readInitialTheme);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(APP_THEME_STORAGE_KEY, theme);
  }, [theme]);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.body.classList.toggle('app-theme-light', theme === 'light');
  }, [theme]);

  const value = useMemo(() => ({
    theme,
    isLightTheme: theme === 'light',
    setTheme,
    toggleTheme: () => setTheme((prev) => (prev === 'light' ? 'dark' : 'light')),
  }), [theme]);

  return (
    <AppThemeContext.Provider value={value}>
      {children}
    </AppThemeContext.Provider>
  );
};

export const useAppTheme = () => {
  const context = useContext(AppThemeContext);
  if (!context) {
    throw new Error('useAppTheme must be used inside AppThemeProvider');
  }
  return context;
};
